module.exports = __webpack_public_path__ + "img/emt-logo-small.8932a1d0.png";